<div class="flex flex-row flex-wrap md:gap-6">
  <div *ngFor="let item of finalArray">
    <div class="left-box">
      <label class="box-content">{{ item }}</label>
    </div>
  </div>
</div>
